let truncate = function(text, length, clamp) {
  // eslint-disable-next-line no-param-reassign
  clamp = clamp || '...';
  let node = document.createElement('div');
  node.innerHTML = text;
  let content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

export default {
  install: function (Vue) {
    Vue.filter('truncate', truncate);
  }
}
